// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__TEfEp","bigColWidth":"Table_bigColWidth__3ePam","biggerColWidth":"Table_biggerColWidth__2VVdx","row":"Table_row__3ABeX","col":"Table_col__CAfTu"};